<template>
  <b-row>
    <b-col>
      <b-form-group
        :label="`Step 2: Enter the 6-digit verification code sent to ${phoneNumber}`"
        label-for="verificationCode"
      >
        <b-row class="mb-1">
          <b-col>
            <b-form-input
              id="verificationCode"
              v-model="$v.code.$model"
              :class="{ 'border-danger': $v.code.$invalid }"
              trim
            />
          </b-col>
          <b-col>
            <b-button @click="onContinue" :disabled="!canContinue"
              >Continue</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button variant="link" @click="onGoBack">Go back</b-button>
          </b-col>
        </b-row>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from "vuelidate";

export default {
  name: "EnterCode",
  props: ["phoneNumber"],
  mixins: [validationMixin],
  validations: {
    code: {
      length: (value) => /^\w{6}$/gi.test(value),
    },
  },
  computed: {
    canContinue() {
      // TODO: has not exceeded verified_count / date_verified limit
      return !this.$v.$invalid;
    },
    code: {
      get() {
        return this.$store.getters["sms/newCode"];
      },
      set(value) {
        this.$store.dispatch("sms/setNewCode", value);
      },
    },
  },
  methods: {
    onContinue() {
      this.$emit("continue");
    },
    onGoBack() {
      this.$store.dispatch("sms/clearNewCode");
      this.$emit("go-back");
    },
    validateField(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>
